<template>
  <div class="w-100 d-flex justify-content-center align-items-center">
    <div
      v-if="userRelated"
      class="dashboard-footer content d-flex flex-column flex-md-row justify-content-md-between"
      :class="{ 'd-none': !isDashboard }"
    >
      <p class="text-center text-md-start mb-0">
        &copy; {{ new Date().getFullYear() }} {{ $t("footer.copyright") }}
      </p>
      <div class="footer-links">
        <ul>
          <li>
            <router-link to="/pages/terms" @click.native="scrollToTop">{{
              $t("footer.links.terms")
            }}</router-link>
          </li>
          <li>
            <router-link to="/pages/privacy" @click.native="scrollToTop">{{
              $t("footer.links.privacy")
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="footer">
      <MailList />
      <hr />
      <FooterLinks />
    </div>
  </div>
</template>

<script>
import FooterLinks from "./FooterLinks.vue";
import MailList from "./MailList.vue";

export default {
  name: "FooterArea",
  components: {
    MailList,
    FooterLinks,
  },
  data() {
    return {
      userRelated: false,
      isDashboard: false,
    };
  },
  mounted() {
    this.getCurrentPage();
  },
  methods: {
    getCurrentPage() {
      const currentPath = this.$router.history.current.path.substring(1);
      if (currentPath.startsWith("dashboard")) this.isDashboard = true;
      if (
        currentPath.startsWith("dashboard") ||
        currentPath.startsWith("login")
      ) {
        this.userRelated = true;
      } else {
        this.userRelated = false;
      }
    },
  },
  watch: {
    $route() {
      const currentPath = this.$router.history.current.path.substring(1);
      if (currentPath.startsWith("dashboard")) this.isDashboard = true;
      if (
        currentPath.startsWith("dashboard") ||
        currentPath.startsWith("login")
      ) {
        this.userRelated = true;
      } else {
        this.userRelated = false;
      }
    },
  },
};
</script>

<style>
hr {
  display: none;
}
.dashboard-footer {
  .footer-links {
    color: #3b3e51;
    ul {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    li {
      a {
        text-decoration: none;
        color: #3b3e51;
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .dashboard-footer {
    .footer-links {
      ul {
        flex-direction: row;
        justify-content: space-between;
        gap: 1rem;
      }
    }
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  hr {
    display: block;
    width: 100%;
    max-width: 1312.38px;
    height: 0.5px;
    background-color: #ffffff;
  }
}
</style>
